"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _url = _interopRequireDefault(require("url"));

var _uploadOptionsBase = _interopRequireDefault(require("./upload-options-base"));

var _initResponseFile = _interopRequireDefault(require("./init-response-file"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Represents the response from the direct binary access initiate request.
 */
var InitResponse = /*#__PURE__*/function (_UploadOptionsBase) {
  _inherits(InitResponse, _UploadOptionsBase);

  var _super = _createSuper(InitResponse);

  /**
   * Constructs a new instance of an init call response.
   *
   * @param {objects} options The options controlling the overall process.
   * @param {DirectBinaryUploadOptions} uploadOptions The options controlling the upload process.
   * @param {Array} uploadFiles List of UploadFile instances that are being uploaded.
   * @param {object} initData The raw data as provided by the init request's response.
   */
  function InitResponse(options, uploadOptions, uploadFiles, initData) {
    var _this;

    _classCallCheck(this, InitResponse);

    _this = _super.call(this, options, uploadOptions);
    _this.uploadFiles = uploadFiles;
    _this.initData = initData;
    return _this;
  }
  /**
   * Retrieves the list of files initialized by the init request.
   *
   * @returns {Array} Information on initialized files. Each item in the array is an
   *  InitResponseFile instance.
   */


  _createClass(InitResponse, [{
    key: "getFiles",
    value: function getFiles() {
      var _this2 = this;

      var _this$initData$files = this.initData.files,
          files = _this$initData$files === void 0 ? [] : _this$initData$files;
      return files.map(function (file, index) {
        return new _initResponseFile.default(_this2.getOptions(), _this2.getUploadOptions(), _this2.uploadFiles[index], file);
      });
    }
    /**
     * Retrieves all the parts for all the files in the upload. The list will be grouped by
     * file, in the same order in which the files were provided to the upload process; the
     * parts themselves will be sorted in the order by which they should be uploaded.
     *
     * @returns {Array} A list of InitResponseFilePart instances.
     */

  }, {
    key: "getAllParts",
    value: function getAllParts() {
      var parts = [];
      this.getFiles().forEach(function (initFile) {
        initFile.getParts().forEach(function (initFilePart) {
          parts.push(initFilePart);
        });
      });
      return parts;
    }
    /**
     * Retrieves the URI that can be called as-is for completing the upload process.
     *
     * @returns {string} URI to invoke for completing the upload process.
     */

  }, {
    key: "getCompleteUri",
    value: function getCompleteUri() {
      var completeURI = this.initData.completeURI; // older versions of the API return file-specific completeURIs. In this case, use the
      // first file's URI.

      if (!completeURI && this.getFiles().length > 0) {
        var fileCompleteURI = this.getFiles()[0].getFileData('completeURI');

        if (fileCompleteURI) {
          completeURI = fileCompleteURI;
        }
      } // older versions of the API return absolute URIs for the completeURI. In this case,
      // convert the URI to relative


      if (completeURI) {
        completeURI = _url.default.parse(encodeURI(completeURI)).pathname; // remove instance context path, if necessary

        var contentIndex = completeURI.indexOf('/content/dam');

        if (contentIndex > 0) {
          completeURI = completeURI.substr(contentIndex);
        }
      }

      return "".concat(this.getUploadOptions().getUrlPrefix()).concat(completeURI);
    }
    /**
     * Converts the class instance into a single object form containing all relevant information.
     *
     * @returns {object} Simplified view of the object's data.
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.initData;
    }
  }]);

  return InitResponse;
}(_uploadOptionsBase.default);

exports.default = InitResponse;